
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class TableColumns extends Vue {
    get salon_col(): ITableColumn[] {
        return [
            {
                title: i18nText("Название"),
                dataIndex: 'name',
                sortField: 'name',
                key: '0',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Партнер"),
                dataIndex: 'partner[name]',
                sortField: 'partner',
                key: '1',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Город"),
                dataIndex: 'city[name]',
                sortField: 'city',
                key: '2',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Активность"),
                dataIndex: 'active',
                sortField: 'active',
                key: '4',
                scopedSlots: {
                    customRender: 'active',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата открытия"),
                key: '5',
                dataIndex: 'opening_date',
                sortField: 'opening_date',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
        ]
    }

    get salon_client_col(): ITableColumn[] {
        return [
            {
                title: i18nText("Имя"),
                key: '0',
                dataIndex: 'name',
                scopedSlots: {
                    filterDropdown: 'filterDropdown',
                    filterIcon: 'filterIcon',
                    customRender: 'name',
                },
            },
            {
                title: i18nText("Номер телефона"),
                key: '1',
                dataIndex: 'phone',
                scopedSlots: {
                    filterDropdown: 'filterDropdown',
                    filterIcon: 'filterIcon',
                    customRender: 'phone',
                },
            },
            {
                title: i18nText("Продано"),
                key: '2',
                dataIndex: 'sold',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Визиты"),
                key: '3',
                dataIndex: 'count_all_visits',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Последний визит"),
                key: '4',
                dataIndex: 'visit_last_date',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата регистрации"),
                key: '5',
                dataIndex: 'created_at',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'dateRegistration'
                }
            }
        ]
    }
}
